import styled from 'styled-components';

export const Container = styled.div`
  max-width: 632px;
  margin: 72px auto 20px auto;

  h2 {
    border-bottom: 1px solid #e6e6e6;
    padding-bottom: 16px;
    margin-bottom: 32px;
  }
`;

export const NoFormAvailable = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto 0;
  text-align: center;

  h1,
  h3 {
    color: rgb(108, 108, 108);
    font-weight: normal;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
